import { Theme, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) => ({
  title: {
    fontFamily: "Inter",
    fontWeight: 600,
    color: "black",
    fontSize: theme.typography.pxToRem(16),
  },
  divider: {
    width: "100%",
    margin: "10px 0px",
    padding: "0",
  },
  container: {
    margin: "20px 0",
  },
  grid: {
    display: "grid",
    marginTop: "20px",
    rowGap: "10px",
    gridTemplateColumns: "repeat(3, 1fr)",
    placeItems: "center",
    "& .MuiCard-root": {
      flex: "1 1 84px",
    },
    "& .MuiCard-root:nth-child(3n + 1)": {
      justifySelf: "start",
    },
    "& .MuiCard-root:nth-child(3n)": {
      justifySelf: "end",
    },
  },
  emptySlot: {
    width: "82px",
    height: "40px",
  },
  error: {
    color: "#CF1B1B",
    fontFamily: "Lato",
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 400,
    margin: "10px auto",
  },
  warning: {
    color: "#747F9D",
    fontFamily: "Lato",
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 400,
    margin: "10px auto",
    gridColumn: "1 / 4",
  },
}));
